// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"46749c9a","403":"fc552b4c","551":"b0ffe9f2"}[chunkId] + ".chunk.js";
};